import React from "react"

const PodatkiTable = () => (
  <table>
    <tbody>
      <tr>
        <th>Znamka vozila</th>
        <td>PEUGEOT 407 / BREAK 2.0 / HDI</td>
      </tr>
      <tr>
        <th>Leto izdelave</th>
        <td>2012</td>
      </tr>
      <tr>
        <th>Število lastnikov</th>
        <td>2</td>
      </tr>
      <tr>
        <th>Barva</th>
        <td>Navaden - ČRNA - SREDNJA</td>
      </tr>
      <tr>
        <th>Vrsta goriva</th>
        <td>Dizel</td>
      </tr>
      <tr>
        <th>Oznaka motorja</th>
        <td>646.963</td>
      </tr>
      <tr>
        <th>Moč</th>
        <td>110 kW</td>
      </tr>
      <tr>
        <th>Prostornina</th>
        <td>2148 ccm</td>
      </tr>
      <tr>
        <th>EURO</th>
        <td>EURO 3</td>
      </tr>
      <tr>
        <th>Prva registracija</th>
        <td>27. avgust, 2012</td>
      </tr>
      <tr>
        <th>Prva registracija (SI)</th>
        <td>18. maj, 2013</td>
      </tr>
    </tbody>
  </table>
)

export default PodatkiTable
